"use client";
import { PrismicNextImage } from "@prismicio/next";
import { PrismicRichText } from "@prismicio/react";
import React from "react";
import s from "./feature-details.module.scss";
import { IoCheckmarkCircleOutline } from "react-icons/io5";

const FeatureDetailsSlice = ({ slice }) => {
  return (
    <div style={{ backgroundColor: slice.primary.bg_color || "#fff" }}>
      <div
        className={`${s.container} ${slice.primary.is_image_left === true ? s.imageLeft : s.imageRight}`}
      >
        <div className={s.contentWrapper}>
          <div className={s.title}>
            <PrismicRichText field={slice.primary.title} />
          </div>
          <div className={s.description}>
            <PrismicRichText field={slice.primary.first_description} />
          </div>
          <div className={s.list}>
            {slice.items &&
              slice.items.map((item, index) => (
                <div key={index} className={s.listItem}>
                  <IoCheckmarkCircleOutline
                    size={24}
                    style={{ flexShrink: 0 }}
                  />
                  <PrismicRichText field={item.label} />
                </div>
              ))}
          </div>
          <div className={s.description}>
            <PrismicRichText field={slice.primary.second_description} />
          </div>
        </div>

        <div className={s.image}>
          <PrismicNextImage field={slice.primary.image} fallbackAlt="" />
        </div>
      </div>
    </div>
  );
};

export default FeatureDetailsSlice;
